import React from 'react';

class ChangePasswordForm extends React.Component{

    static defaultProps = {
        formName: "changePasswordForm",
        method:"POST",
        submitBtnText: "Save",
        className: ""
    };
    
    render(){
        const { formName, submitBtnText, className } = this.props;
        return (
            <form className={'form ' + className} autoComplete="off" id={formName} name={formName} noValidate="" method="POST">
                <div className="form-group">
                    <label htmlFor="inputPasswordOld">Current Password</label>
                    <input type="password" className="form-control" id="inputPasswordOld" required="" />
                </div>
                <div className="form-group">
                    <label htmlFor="inputPasswordNew">New Password</label>
                    <input type="password" className="form-control" id="inputPasswordNew" required="" />
                    <span className="form-text small text-muted">
                        The password must be 8-20 characters, and must <em>not</em> contain spaces.
                    </span>
                </div>
                <div className="form-group">
                    <label htmlFor="inputPasswordNewVerify">Verify</label>
                    <input type="password" className="form-control" id="inputPasswordNewVerify" required="" />
                    <span className="form-text small text-muted">
                        To confirm, type the new password again.
                    </span>
                </div>
                <div className="form-group">
                    <button type="submit" className="btn btn-primary btn-lg float-right">{submitBtnText}</button>
                </div>
            </form>
        );
    }
}

export default ChangePasswordForm;
